// File#: _1_animated-headline
// Usage: codyhouse.co/license
// Modified by Digitalspace

import './animated-headline.css'

export default function animateHeadline() {
  var textAnim = document.getElementsByClassName('text-anim');
  
  if(!textAnim || textAnim.length === 0) {
    return;
  }

  for(var i = 0; i < textAnim.length; i++) {
    initAnimation(textAnim[i]);
  }

  function initAnimation(element) {
    var words = element.getElementsByClassName('text-anim__word');
    if(words.length === 0) return;
    
    var currentIndex = 0;
    
    // Hide ALL words initially - start fresh
    for(var i = 0; i < words.length; i++) {
      words[i].style.opacity = '0';
    }
    
    // Start animation immediately
    animateCycle();
    
    function animateCycle() {
      var word = words[currentIndex];
      
      // Fade in (takes 600ms based on CSS transition)
      setTimeout(function() {
        word.style.opacity = '1';
      }, 100);
      
      // Wait for fade-in + 7 seconds display, then fade out
      setTimeout(function() {
        word.style.opacity = '0';
      }, 7700); // 100 + 600 (fade-in) + 7000 (display)
      
      // After fade out (600ms) + 1 second pause, move to next word
      setTimeout(function() {
        currentIndex = (currentIndex + 1) % words.length;
        animateCycle();
      }, 9300); // 7700 + 600 (fade-out) + 1000 (pause)
    }
  }
};
